
import TitleBox2 from '@/components/CSS/TitleBox2'
import TitleBox from '@/components/CSS/TitleBox'
import GoodsSimpleMessage from '@/components/CSS/GoodsSimpleMessage'
import OrderBoxStatus from '@/components/OrderBox/OrderBoxStatus.vue'
import Flow from '@/components/im/Flow'
import GoodsQqGroup from '@/components/GoodsDesc/GoodsQqGroup'
import TimeCountdown from '@/components/TimeCountdown'
import GeneralGoodsDetailTable from '@/components/GeneralGoodsDetail/Table'
import GeneralGoodsDetailGoods from '@/components/GeneralGoodsDetail/Goods'
import { orderStatusByBuyer } from '@/enum/localEnum'
import RightButtons from '@/components/PZRightButtons'
import { getSecondsRemaining } from '@/utils/time'
import PZButton from '@/components/PZButton'
import { mapGetters } from 'vuex'
import { formatCount } from '~/utils'
import OrderBoxKan from '@/components/OrderBox/OrderBoxKan.vue'

const PendingPayment = 'PendingPayment' //待付款
const DealDone = 'DealDone' //已成交
const Pending = 'Pending' //待成交

export default {
	components: {
		GoodsQqGroup,
		TimeCountdown,
		TitleBox,
		TitleBox2,
		GoodsSimpleMessage,
		PZButton,
		Flow,
		GeneralGoodsDetailTable,
		GeneralGoodsDetailGoods,
		OrderBoxStatus,
		RightButtons,
		OrderBoxKan
	},
	data() {
		return {
			orderStatusByBuyer,
			PendingPayment,
			DealDone,
			Pending,
			orderStatus: null,
			loading: true,
			orderNo: null,
			timers: '',
			flow: [],
			orderDetailsData: null,
			centerDialogVisible1: false, //取消订单
			centerPayDialogVisible: false, // 支付方式
			centerPayQRDialogVisible: false, // 关闭支付提示
			parInfo: {}, //创建订单回调信息
			clickLoading: true,
			orderFlow: null,
			centerState: null,

			compensationVisible: false, // 包赔信息弹窗
			compensationDetail: '', //包赔规则
			compensationAttentionItems: '', // 注意事项
			afterSalesOrdersData: {}, // 售后信息
			questionList: {}, // 问题列表
			afterSalesOrdersDialog: false, // 售后弹窗
			serveDialogVisible1: false,
			detailsDataTable: {},
			countDownTime: null,
			wantNum: 0,
			wantBuyText: '',

			// 部分退款相关
			partRefundDialog: false,
			currentRefundOrder: null, // 当前退款的订单
			refundForm: {
				refundType: 'RATIO', // RATIO-按金额比例, QUANTITY-按商品数量
				refundAmount: '',
				refundQuantity: 1 // 退款商品数量
			},
			refundLoading: false,
			lastMoney: {
				handAmount: 0,
				commissionFee: 0
			},
			refundError: '', // 退款金额错误提示
			typeIndex: 0 // 类型索引
		}
	},
	watch: {
		$route: {
			handler: function (route) {
				this.orderNo = this.$route.query.orderNo
				this.getOrderDetails()
			}
		}
	},
	computed: {
		...mapGetters({
			payInfo: 'game/payInfo',
			userAccount: 'user/userAccount',
			/**
			 * 公共剩余砍价次数
			 */
			bargainCountConfig: 'bargain/bargainCountConfig'
		}),
		// 判断按商品数量是否禁用（商品数量为1时禁用）
		isQuantityDisabled() {
			if (!this.currentRefundOrder) return false
			return this.currentRefundOrder.goodsNum === 1
		},
		rightButtons() {
			const arr = []

			if (this.orderDetailsData) {
				const { waitPayStatus, orderStatus, goodsCatalogueId, compensationPdfUrl, orderType, payChannels, payEndTime } = this.orderDetailsData
				if (orderStatus === 'WAIT_PAY' && [1, 2, 3, 4].includes(waitPayStatus)) {
					arr.push({
						text: '取消订单',
						handler: this.cancellationOrder
					})
				}

				if (orderStatus === 'COMPLETE' && goodsCatalogueId === 6 && compensationPdfUrl) {
					arr.push({
						text: '包赔证明',
						handler: () => this.lockUrl(this.orderDetailsData)
					})
				}

				if (orderStatus === 'PAY_SUCCESS' && orderType === 'GENERAL') {
					arr.push({
						text: '官方客服介入',
						handler: () => {
							this.serveDialogVisible1 = true
						}
					})
				}

				if (orderStatus === 'PAY_SUCCESS' && orderType === 'GENERAL') {
					arr.push({
						text: '部分退款',
						handler: () => {
							this.openPartRefundDialog(this.orderDetailsData)
						}
					})
				}

				if (orderStatus === 'PAY_SUCCESS' || (orderStatus === 'COMPLETE' && orderType === 'GENERAL')) {
					arr.push({
						text: '进入群聊',
						handler: () => {
							this.showIm(this.orderDetailsData)
						},
						primary: true
					})
				}
			}

			return arr
		},

		goodsPriceInfo() {
			const singlePrice = {
				label: '单价',
				value: `￥${this.orderDetailsData.transactionPrice}`
			}
			const num = {
				label: '出售数量',
				value: `x${this.orderDetailsData.goodsNum}`
			}
			let serveMoney = {}
			if (this.orderDetailsData.orderStatus === 'PAY_SUCCESS') {
				serveMoney = {
					label: '服务费',
					value: `￥${this.orderDetailsData.commissionFee}`
				}
			}
			const shouldPay = {
				label: ['COMPLETE'].includes(this.orderDetailsData.orderStatus) ? '到手金额' : '总价',
				value: ['COMPLETE'].includes(this.orderDetailsData.orderStatus) ? `￥${this.orderDetailsData.sellerRemitAmount}` : `￥${this.orderDetailsData.receivablePaymentAmount}`,
				valueStyle: {
					color: this.orderDetailsData.orderStatus === 'PAY_SUCCESS' ? '' : 'var(--color)'
				}
			}

			let handAmount = {}
			if (this.orderDetailsData.orderStatus === 'PAY_SUCCESS') {
				handAmount = {
					label: '到手金额',
					value: `￥${this.orderDetailsData.receivedAmount}`,
					valueStyle: {
						color: 'var(--color)'
					}
				}
			}

			let liquidatedDamagesText = ''
			if (this.orderDetailsData.paySellerLiquidatedDamages > 0) {
				liquidatedDamagesText = '违约金'
			}
			const liquidatedDamages = {
				label: liquidatedDamagesText,
				// TODO: 字段可能不对
				value: `￥${this.orderDetailsData.paySellerLiquidatedDamages}`,
				valueStyle: {
					color: 'var(--color)'
				}
			}

			const refund = {
				label: `${this.orderDetailsData.refundStatus === 1 ? '退款金额' : '待退款'}`,
				// TODO: 字段可能不对
				value: `￥${this.orderDetailsData.refundFee}`,
				valueStyle: {
					color: 'var(--color)'
				}
			}

			const arr = [singlePrice, num, serveMoney, shouldPay, handAmount]
			if (liquidatedDamagesText) {
				arr.push(liquidatedDamages)
			}

			if (this.orderDetailsData.orderStatus === 'REFUND_CANCEL') {
				arr.push(refund)
			}

			return arr
		},
		tableItems() {
			const list = [
				{
					propertyName: '订单类型',
					value: this.orderDetailsData.orderTypeName
				},
				{
					propertyName: '订单编号',
					value: this.orderDetailsData.goodsNo,
					type: 'copy'
				},
				{
					propertyName: '单价',
					value: this.orderDetailsData.transactionPrice
				},
				{
					propertyName: '购买数量',
					value: this.orderDetailsData.goodsNum
				},
				{
					propertyName: '应付款',
					value: this.orderDetailsData.receivablePaymentAmount
				},
				{
					propertyName: '实付款',
					value: this.orderDetailsData.actualPaymentAmount
				},
				{
					propertyName: '支付时间',
					value: this.orderDetailsData.payTime
				},
				{
					propertyName: '商品名称',
					value: JSON.parse(this.orderDetailsData.spuSnapshot)?.title
				}
			]
			if (this.orderDetailsData.goodsCatalogueId !== 6) {
				list.push(
					{
						propertyName: '已选套餐',
						value: JSON.parse(this.orderDetailsData.skuSnapshot)?.skuTitle
					},
					{
						propertyName: '套餐价格',
						value: JSON.parse(this.orderDetailsData.skuSnapshot)?.skuPrice
					}
				)
			}
			return list
		},
		goodsItems() {
			return this.detailsDataTable.propertyConfigVOS
		}
	},
	methods: {
		getGoodsType(name) {
			if (name === 'COMPLETE') {
				return '已出售'
			} else if (name === 'REFUND_CANCEL' || name === 'CANCEL') {
				return '交易取消'
			} else if (name === 'PAY_SUCCESS') {
				return '交易中'
			}
		},
		openPartRefundDialog(item) {
			this.currentRefundOrder = item
			const { commissionFee, receivedAmount } = this.currentRefundOrder
			this.lastMoney.commissionFee = 0
			this.lastMoney.handAmount = receivedAmount + commissionFee
			this.refundForm = {
				refundType: 'RATIO',
				refundAmount: '',
				refundQuantity: 1
			}
			this.refundError = '' // 清空错误提示
			this.partRefundDialog = true
			this.calculateRemaining(1)
		},
		// 切换退款方式
		changeRefundType(type) {
			this.refundForm.refundType = type
			this.refundError = '' // 清空错误提示
			// 切换时重置相关字段
			if (type === 'RATIO') {
				this.refundForm.refundAmount = ''
				this.calculateRemaining(1)
			} else if (type === 'QUANTITY') {
				this.refundForm.refundQuantity = 1
				this.$api
					.getHandMoney({
						num: 1,
						orderId: this.currentRefundOrder.orderId,
						type: 2
					})
					.then(res => {
						if (res.success) {
							this.lastMoney = res.data
							this.refundError = '' // 清空错误提示
						} else {
							// 显示错误提示
							this.refundError = res.info || '退款金额验证失败'
						}
					})
					.catch(err => {
						this.refundError = '计算失败，请稍后重试'
					})
			}
		},
		// 处理数量变化
		handleQuantityChange(value) {
			// // 根据商品数量自动计算退款金额
			// if (this.currentRefundOrder) {
			// 	const unitPrice = parseFloat(this.currentRefundOrder.transactionPrice || 0)
			// 	this.refundForm.refundAmount = (unitPrice * value).toFixed(2)
			// }
			this.$api
				.getHandMoney({
					num: this.refundForm.refundQuantity,
					orderId: this.currentRefundOrder.orderId,
					type: 2
				})
				.then(res => {
					if (res.success) {
						this.lastMoney = res.data
						this.refundError = '' // 清空错误提示
					} else {
						// 显示错误提示
						this.refundError = res.info || '退款金额验证失败'
					}
				})
				.catch(err => {
					this.refundError = '计算失败，请稍后重试'
				})
		},
		// 计算剩余金额
		calculateRemaining(type) {
			// 如果 type 不是数字（比如来自 input 事件的字符串值），则使用默认值 1
			const apiType = typeof type === 'number' ? type : 1

			console.log(this.currentRefundOrder)
			this.$api
				.getHandMoney({
					amount: Number(this.refundForm.refundAmount),
					orderId: this.currentRefundOrder.orderId,
					type: apiType
				})
				.then(res => {
					if (res.success) {
						this.lastMoney = res.data
						this.refundError = '' // 清空错误提示
					} else {
						// 显示错误提示
						this.refundError = res.info || '退款金额验证失败'
					}
				})
				.catch(err => {
					this.refundError = '计算失败，请稍后重试'
				})
		},
		// 提交部分退款
		async submitPartRefund() {
			if (!this.refundForm.refundAmount && this.refundForm.refundType === 'RATIO') {
				this.$message.error('请输入退款金额')
				return
			}

			// 如果有错误提示，不允许提交
			if (this.refundError) {
				this.$message.error(this.refundError)
				return
			}

			try {
				// 调用退款接口 - 根据实际API调整
				const res = await this.$api.upOrderRefund({
					orderId: this.currentRefundOrder.orderId,
					type: this.refundForm.refundType === 'RATIO' ? 1 : 2,
					amount: Number(this.refundForm.refundAmount),
					num: Number(this.refundForm.refundQuantity)
				})

				if (res.success) {
					this.$message.success('退款申请提交成功')
					this.partRefundDialog = false
					this.getOrderDetails()
				} else {
					this.$message.error(res.info || '退款申请失败')
				}
			} finally {
				this.refundLoading = false
			}
		},
		getSecondsRemaining(endTime) {
			return getSecondsRemaining(endTime)
		},
		// 官方客服介入
		serveInto(item) {
			this.$api.serviceIntervene({ id: item.orderId }).then(res => {
				if (res.success) {
					this.$message.success('客服介入成功')
				} else {
					this.$message.error(res.info)
				}
				this.serveDialogVisible1 = false
			})
		},
		// 申请售后
		async toPage(item) {
			try {
				const { data: orderDetails } = await this.$api.orderDetails({ orderNo: item.orderNo })
				this.afterSalesOrdersData = orderDetails

				const { data: questionData } = await this.$api.afterSalesQuestionListAPI({ goodsCatalogueId: item.goodsCatalogueId })
				this.questionList = questionData
				this.afterSalesOrdersDialog = true
			} catch (error) {
				this.$message.error(error.info || '获取售后信息失败')
			}
		},
		getWantAndSeenNum(goodsNo) {
			this.$api.getGoodsWantAndSeenNum({ action: [{ goodsNo, onStandTime: '' }] }).then(res => {
				if (res.success) {
					this.wantNum = res.data[0].wantNum || 0
					this.wantBuyText = formatCount(this.wantNum)
				}
			})
		},
		async getOrderDetails() {
			this.$api.orderDetails({ orderNo: this.orderNo }).then(res => {
				this.loading = true
				if (!res.success) {
					this.loading = false
					this.$message.error(res.info)
					return
				}

				this.orderDetailsData = res.data
				this.orderFlow = res.data?.flowRecordVOS
				if (this.orderDetailsData.goodsNo) {
					this.getWantAndSeenNum(this.orderDetailsData.goodsNo)
				}
			})
		},
		onQuestionList(val) {
			let data = {
				orderNo: this.afterSalesOrdersData.orderNo,
				questionTypeId: val.questionTypeId
			}
			this.$api.afterSalesV2ApplyAPI(data).then(res => {
				if (!res.success) return this.$message.error(res.info)
				this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)
				let data = {
					targetId: res.data.buyerAfterSalesGroupId,
					conversationType: 3
				}
				this.$store.dispatch('ry/join', data)
				this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
				this.$store.commit('ry/SET_GLOBAL_SHOW_CHAT', true)
				this.$store.commit('ry/SET_ORDER_FLOW', [])
				this.afterSalesOrdersDialog = false
			})
		},
		lockUrl(item) {
			window.open(item.compensationPdfUrl)
		},
		showIm(item) {
			// 检查是否有群聊ID
			if (!item.imGroupId) {
				this.$message.error('暂无可用的群聊')
				return
			}

			// 获取订单流转信息
			this.$api
				.getOrderFlow({ orderNo: item.orderNo })
				.then(res => {
					if (res.success) {
						let { orderNo, title, goodsImage, gameName, createTime } = item
						let { name, transactionPrice, orderTypeName, orderStatus } = res.data

						// 设置订单流转数据
						this.$store.dispatch('ry/setOrderFlow', res.data.orderFlow)
						this.$store.dispatch('ry/setOrderGoods', {
							orderNo,
							title,
							goodsImg: goodsImage,
							gameIdName: gameName,
							orderTypeName,
							statusName: orderStatus,
							createTime,
							transactionPrice,
							compensationName: name
						})

						// 显示订单流转面板
						this.$store.commit('ry/SET_ORDER_FLOW_SHOW', true)

						// 打开聊天窗口
						this.$store.commit('ry/SET_GLOBAL_SHOW_CHAT', true)

						// 设置会话筛选为普通消息
						this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)

						// 通过融云SDK获取会话信息
						this.$RongIMLib
							.getConversation({
								conversationType: 3,
								targetId: item.imGroupId.toString()
							})
							.then(async ({ code, data }) => {
								if (!code && data) {
									// 构造会话数据
									let conversationData = {
										...data,
										orderNo: item.orderNo
									}

									// 获取群信息以获取群名称
									try {
										const groupRes = await this.$api.findGroup({
											action: { groupId: item.imGroupId }
										})
										if (groupRes.success && groupRes.data) {
											// 将群名称设置到会话数据中
											conversationData = {
												...conversationData,
												name: groupRes.data.name || groupRes.data.groupName || conversationData.name
											}
										}
									} catch (groupErr) {}

									// 通过 EventBus 触发事件，让 IM 组件调用 selectConversation
									this.$nuxt.$emit('im:selectConversation', {
										conversationData
									})
								} else {
									this.$message.error('获取会话信息失败')
								}
							})
							.catch(err => {
								this.$message.error('进入群聊失败，请稍后重试')
							})
					} else {
						this.$message.error(res.info || '获取订单信息失败')
					}
				})
				.catch(err => {
					this.$message.error('进入群聊失败，请稍后重试')
				})
		},
		filters(list) {
			let arr = []
			;(list || []).forEach(item => {
				item['_custom_status'] = 1 // 已完成

				if (item?.orderFlow?.length > 0) {
					// 有未完成的节点
					if (item?.orderFlow?.some(vo => vo.status === 0)) {
						item['_custom_status'] = 0 // 未完成
					}
					arr.push(item)
				}
			})
			//

			return arr
		},
		renameKey(arr, oldKey, newKey) {
			return arr.map(obj => {
				if (oldKey in obj) {
					obj[newKey] = obj[oldKey] // 将旧的 key 的值赋给新的 key
					delete obj[oldKey] // 删除旧的 key
				}
				return obj
			})
		},
		submitForm() {
			this.$message.error('暂无接口')
		},
		goBackList() {
			if (this.$route.query.parPage) {
				this.$router.push({
					path: '/account/buyerList',
					query: { status: this.orderDetailsData.orderStatus }
				})
			} else {
				this.$router.go(-1)
			}
		},
		// 立即支付
		paymentSubmit() {
			let data = {
				orderNo: this.orderDetailsData.orderNo
			}
			this.$api.orderDetails(data).then(res => {
				if (res.success) {
					this.parInfo = {
						...res.data,
						payTotalMoney: res.data.goodsNum * res.data.goodsPrice,
						transactionGoodsPrice: this.orderDetailsData.transactionPrice
					}
					this.centerPayDialogVisible = true
					this.$nextTick(() => {
						this.$refs['orderPayRef'].getPayqrCodeUrl(this.parInfo)
					})
				} else {
					this.$message.error(res.info)
				}
			})
		},
		// 取消订单弹窗
		async cancellationOrder() {
			this.centerState = this.orderDetailsData.orderType
			// 公共获取剩余砍价次数
			await this.$store.dispatch('bargain/onGetBargainCount', { goodsNo: this.orderDetailsData.goodsNo })
			this.centerDialogVisible1 = true
		},
		// 取消订单提交
		ancelOrderSubmit() {
			if (this.orderDetailsData.orderStatus == 'WAIT_PAY') {
				if (!this.clickLoading) return
				this.clickLoading = false
				let data = {
					orderNo: this.$route.query.orderNo
				}
				this.$api.getOrderCancelOrder(data).then(res => {
					this.centerDialogVisible1 = false
					if (res.success) {
						this.$message.success('订单取消成功')
						this.centerDialogVisible1 = false
						this.clickLoading = true
						this.getOrderDetails()
					} else {
						this.$message.error(res.info)
					}
				})
			}
		},
		// 关闭支付方式弹窗
		closePayDialogVisible(done) {
			this.centerPayQRDialogVisible = true
			if (!this.centerPayQRDialogVisible) {
				done()
			}
		},
		// 退出支付方式
		closePayDialogOkVisible() {
			this.centerPayQRDialogVisible = false
			this.centerPayDialogVisible = false
			this.$refs['orderPayRef'].closeDialogVisible()
		},
		// 支付成功回调
		paySuccess(payStatus, msg = '支付失败') {
			if (payStatus === 'PAY_SUCCESS') {
				this.$message.success('支付成功！')
				// 判断是否是道具交易
				this.$router.push({
					path: '/confirmOrder/paymentCallback',
					query: { orderNo: this.parInfo.orderNo, status: this.orderDetailsData.isPropTrading ? '3' : '1' }
				})
			} else {
				this.closePayDialogOkVisible()
				this.getOrderDetails()
			}
		},
		// 联系客服
		getClickCustomerService(item) {
			console.log(1)

			let data = {
				orderNo: item.orderNo
			}
			this.$api.getOrderCustomerService(data).then(res => {
				if (res.success) {
					if (res.data) {
						this.$store.dispatch('ry/join', { targetId: res.data.id, conversationType: 1 })
					} else {
						this.$message({
							message: '暂无客服值班',
							type: 'error'
						})
					}
				}
			})
		},
		// 查看包赔说明
		compensationVisibleShow(item, index) {
			this.compensationDetail = item.detail
			this.compensationAttentionItems = item.attentionItems
			this.compensationVisible = true
		},
		// 滚动到订单凭证
		scrollToOrderProof() {
			this.$nextTick(() => {
				if (this.$refs.orderProof) {
					this.$refs.orderProof.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					})
				}
			})
		},
		// 跳转到商品详情页（重新购买）
		goToGoodsDetails() {
			const { goodsNo, goodsCatalogueId, orderType } = this.orderDetailsData
			if (!goodsNo) {
				this.$message.warning('商品信息不完整')
				return
			}
			// 根据订单类型判断跳转到不同的商品详情页
			const detailsPath = orderType === 'GENERAL' ? 'generalGoodsDetails' : 'goodsDetails'
			const url = `/${detailsPath}/${goodsNo}${goodsCatalogueId ? '/' + goodsCatalogueId : ''}`
			this.$router.push(url)
		}
	},
	created() {
		this.$store.dispatch('ry/setOrderFlow', [])
		this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
		this.orderNo = this.$route.query.orderNo
	},
	async mounted() {
		this.getOrderDetails()
	}
}
